import RewardsBoostCampaignSchema from "@apps/rewards/schemas/RewardsBoostCampaignSchema";
import { Infer, object } from "superstruct";

export const RewardsBoostCampaignResponseSchema = object({
    boostCampaign: RewardsBoostCampaignSchema,
});

export type RewardsBoostCampaignResponseType = Infer<
    typeof RewardsBoostCampaignResponseSchema
>;
